import { render, staticRenderFns } from "./questionnaireItemChoices.vue?vue&type=template&id=71c005f2&"
import script from "./questionnaireItemChoices.vue?vue&type=script&lang=js&"
export * from "./questionnaireItemChoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports